// @refresh reload
import { StartClient, mount } from "@solidjs/start/client";
import "solid-devtools";

mount(() => <StartClient />, document.getElementById("app")!);

let reloading = false;
const safeReload = () => {
  if (!reloading) {
    reloading = true;
    setTimeout(() => window.location.reload(), 500);
  }
};

const isUnhandledImportRejection = (message: string) =>
  message.includes("Failed to fetch dynamically imported module") ||
  message.includes("Importing a module script failed") ||
  message.includes("Unexpected token '<'"); // server returned HTML instead of JS

window.addEventListener("unhandledrejection", (event) => {
  const message = String(event.reason?.message || event.reason || "");
  if (isUnhandledImportRejection(message)) {
    console.warn("Unhandled import rejection — reloading...");
    safeReload();
  }
});
window.addEventListener("error", (event) => {
  if (isUnhandledImportRejection(event.message || "")) {
    console.warn("Detected missing build chunk — reloading...");
    safeReload();
  }
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js", { scope: "/" }).then((registration) => {
    registration.update();

    // Check periodically for new deployments
    setInterval(
      () => {
        registration.update();
      },
      10 * 60 * 1000,
    );

    // On browser tab activation, check for SW updates
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        registration.update();
      }
    });

    // Reload when a new SW takes control (i.e. when there's a new deployment)
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      console.log("New service worker activated — reloading...");
      safeReload();
    });
  });
}
